export class IDBWrapper {
    dbName: string
    storeName: string
    version: number
    db: IDBDatabase | null
    autoIncrement: boolean = false

    constructor(dbName: string, storeName: string, version = 1, autoIncrement = false) {
        this.dbName = dbName
        this.storeName = storeName
        this.version = version
        this.db = null
        this.autoIncrement = autoIncrement
    }

    async open() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName, this.version)

            request.onupgradeneeded = (event) => {
                this.db = (event.target as IDBOpenDBRequest).result
                if (!this.db.objectStoreNames.contains(this.storeName)) {
                    this.db.createObjectStore(this.storeName, { keyPath: 'id', autoIncrement: this.autoIncrement })
                }
            }

            request.onsuccess = () => {
                this.db = request.result
                resolve(this.db)
            }

            request.onerror = () => reject(request.error)
        })
    }

    async close() {
        return new Promise((resolve) => {
            this.db?.close()
            resolve(true)
        })
    }

    async getStore(mode: IDBTransactionMode = 'readonly') {
        if (!this.db) await this.open()
        return this.db.transaction(this.storeName, mode).objectStore(this.storeName)
    }

    async add(data) {
        return new Promise(async (resolve, reject) => {
            const store = await this.getStore('readwrite')
            const request = store.add(data)
            request.onsuccess = () => resolve(request.result)
            request.onerror = () => reject(request.error)
        })
    }

    async get(id) {
        return new Promise(async (resolve, reject) => {
            const store = await this.getStore()
            const request = store.get(id)
            request.onsuccess = () => resolve(request.result)
            request.onerror = () => reject(request.error)
        })
    }

    async getAll() {
        return new Promise(async (resolve, reject) => {
            const store = await this.getStore()
            const request = store.getAll()
            request.onsuccess = () => resolve(request.result)
            request.onerror = () => reject(request.error)
        })
    }

    async update(data) {
        return new Promise(async (resolve, reject) => {
            const store = await this.getStore('readwrite')
            const request = store.put(data)
            request.onsuccess = () => resolve(request.result)
            request.onerror = () => reject(request.error)
        })
    }

    async delete(id) {
        return new Promise(async (resolve, reject) => {
            const store = await this.getStore('readwrite')
            const request = store.delete(id)
            request.onsuccess = () => resolve(true)
            request.onerror = () => reject(request.error)
        })
    }

    async clear() {
        return new Promise(async (resolve, reject) => {
            const store = await this.getStore('readwrite')
            const request = store.clear()
            request.onsuccess = () => resolve(true)
            request.onerror = () => reject(request.error)
        })
    }
}
